<template lang="">
    <v-app>
        <v-container fluid>
            <v-card elevation="0">
                <v-card-title>
                    <span class="display-1">Históricos</span>
                    <v-spacer></v-spacer>
                </v-card-title>
                <!--TABS-->
                <div class="mb-4 mt-2 pl-3 pr-3">
                    <v-tabs
                        v-model="tipoEnsayo"
                        align-with-title
                        color="black"
                        >
                        <v-tab>ENSAYOS</v-tab>
                        <v-tab>HORNOS</v-tab>
                        <v-tab>SECADERO</v-tab>
                        </v-tabs>
                    <history-ensayos v-if="tipoEnsayo == 0"></history-ensayos>
                    <history-hornos v-if="tipoEnsayo == 1"></history-hornos>
                    <history-secadero v-if="tipoEnsayo == 2"></history-secadero>
                </div>
            </v-card>
        </v-container>
  </v-app>
</template>
<script>
import HistoryEnsayos from "@/components/HistoryEnsayos.vue";
import HistoryHornos from "@/components/HistoryHornos.vue";
import HistorySecadero from "@/components/HistorySecadero.vue";

export default {
  data() {
    return {
      tipoEnsayo: 0,
    }
  },
  components:{
    HistoryHornos, HistoryEnsayos, HistorySecadero,
  }
};
</script>
